
/* injects from baggage-loader */

import loadTypes from 'utils/loadTypes'

export const BILLING_PLANS = loadTypes('BILLING_PLANS')
export const BILLING_SET_PLAN = loadTypes('BILLING_SET_PLAN')
export const BILLING_CANCEL_PLAN = loadTypes('BILLING_CANCEL_PLAN')
export const BILLING_UPDATE_PAYMENT = loadTypes('BILLING_UPDATE_PAYMENT')
export const BILLING_PREVIEW_PLAN = loadTypes('BILLING_PREVIEW_PLAN')
export const BILLING_FETCH_INVOICES = loadTypes('BILLING_FETCH_INVOICES')

const initialState = {
  plans: null,
  invoices: null,
  plansFetching: null,
  invoicesFetching: null,
  planPreview: null,
  planPreviewFetching: null,
  isBusy: null,
  invoicePreviewError: null
}

const disabledBillingPlans = ['startery', 'plusy', 'proy', 'proyearly']

const invoiceReducer = invoices => {
  return {
    invoices: invoices.map(invoice => {
      const {paid, total, currency, date, lines, charge} = invoice
      const {plan: {name: planName}} = lines.data[0]
      const resultInvoice = {
        paid,
        total: total / 100,
        currency,
        date: date * 1000,
        plan: planName
      }
      if (charge) {
        const {source: {object, brand, last4}} = charge
        resultInvoice.source = {
          type: object,
          brand,
          last4
        }
      }

      return resultInvoice
    })
  }
}

const processPlanPreview = invoice => {
  const {
    discount,
    total,
    currency,
    period_end: periodEnd,
    period_start: periodStart,
    trialEndDate
  } = invoice
  return {
    total: total / 100,
    currency: currency.toUpperCase(),
    periodEnd: periodEnd * 1000,
    periodStart: periodStart * 1000,
    trialEndDate,
    coupon: discount ? discount.coupon : null
  }
}

export default function billing(state = initialState, action) {
  switch (action.type) {
    case BILLING_SET_PLAN.REQUEST:
    case BILLING_CANCEL_PLAN.REQUEST:
    case BILLING_UPDATE_PAYMENT.REQUEST:
      return {
        ...state,
        isBusy: true
      }
    case BILLING_PREVIEW_PLAN.REQUEST:
      return {
        ...state,
        planPreviewFetching: true,
        invoicePreviewError: null
      }
    case BILLING_SET_PLAN.SUCCESS:
    case BILLING_CANCEL_PLAN.SUCCESS:
    case BILLING_UPDATE_PAYMENT.SUCCESS:
      return {
        ...state,
        isBusy: false
      }
    case BILLING_PREVIEW_PLAN.SUCCESS:
      return {
        ...state,
        planPreviewFetching: false,
        planPreview: processPlanPreview(action.response)
      }
    case BILLING_SET_PLAN.FAILURE:
    case BILLING_CANCEL_PLAN.FAILURE:
    case BILLING_UPDATE_PAYMENT.FAILURE:
      return {
        ...state,
        isBusy: false
      }
    case BILLING_PREVIEW_PLAN.FAILURE:
      return {
        ...state,
        planPreviewFetching: false,
        invoicePreviewError: action.message
      }
    case BILLING_PLANS.REQUEST:
      return {
        ...state,
        plansFetching: true
      }
    case BILLING_PLANS.SUCCESS:
      return {
        ...state,
        plans: action.response.filter(plan => !disabledBillingPlans.includes(plan.id)),
        plansFetching: false
      }
    case BILLING_PLANS.FAILURE:
      return {
        ...state,
        plansFetching: false
      }
    case BILLING_FETCH_INVOICES.REQUEST:
      return {
        ...state,
        invoicesFetching: true
      }
    case BILLING_FETCH_INVOICES.SUCCESS:
      return {
        ...state,
        ...invoiceReducer(action.response),
        invoicesFetching: false
      }
    case BILLING_FETCH_INVOICES.FAILURE:
      return {
        ...state,
        invoicesFetching: false
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/billing/index.js